document.addEventListener("DOMContentLoaded", () => {
  // ===== FUNÇÕES HELPER (INTACTAS) =====
  const traducaoStatus = {
    deliveryStatus: {
      null: "Aguardando envio",
      in_transit: "Em trânsito",
      delivered: "Entregue",
      cancelled: "Cancelado",
      fulfilled: "Enviado",
      DELIVERED: "Entregue",
      IN_TRANSIT: "Em trânsito",
      SHIPPED: "Despachado",
      NEW: "Criado",
      READY_FOR_SHIPPING: "Pronto para envio",
      TO_BE_DELIVERED: "Saiu para entrega",
      to_be_delivered: "Saiu para entrega",
    },
    paymentStatus: {
      paid: "Pago",
      pending: "Pendente",
      refunded: "Reembolsado",
      failed: "Falhou",
    },
  };

  function calcularProgresso(statusEntrega) {
    switch (statusEntrega) {
      case null:
      case "pending":
      case "NEW":
        return 33; // Confirmado
      case "in_transit":
      case "fulfilled":
      case "IN_TRANSIT":
      case "SHIPPED":
      case "READY_FOR_SHIPPING":
      case "TO_BE_DELIVERED":
      case "to_be_delivered":
        return 66; // Em Trânsito
      case "delivered":
      case "DELIVERED":
        return 100; // Entregue
      case "cancelled":
        return 0; // Cancelado
      default:
        return 33; // Padrão
    }
  }

  function corProgresso(statusEntrega) {
    switch (statusEntrega) {
      case "delivered":
      case "DELIVERED":
        return "linear-gradient(90deg, #4caf50, #2e7d32)"; // Verde
      case "cancelled":
        return "linear-gradient(90deg, #f44336, #c62828)"; // Vermelho
      case "in_transit":
      case "fulfilled":
      case "IN_TRANSIT":
      case "SHIPPED":
      case "READY_FOR_SHIPPING":
      case "TO_BE_DELIVERED":
      case "to_be_delivered":
        return "linear-gradient(90deg, #ff9800, #f57c00)"; // Laranja
      default:
        return "linear-gradient(90deg, #5223DE, #411baf)"; // Roxo (padrão do print)
    }
  }

  function normalizeAcompanharUrl(rawUrl, trackingNumbers = []) {
    if (!rawUrl || typeof rawUrl !== "string") {
      if (trackingNumbers.length > 0) {
        const n = String(trackingNumbers[0]).trim();
        return `https://elements.acompanharentrega.com.br/?tpDoc=4&doc=${encodeURIComponent(n)}`;
      }
      return null;
    }
    try {
      const u = new URL(rawUrl);
      if (u.hostname.includes("acompanharentrega.com.br")) {
        const qs = u.search;
        const enc = qs.match(/tpDoc=(\d+)%3D([\d-]+)/i);
        const plain = qs.match(/tpDoc=(\d+)=([\d-]+)/i);
        if (enc) {
          u.search = `?tpDoc=${enc[1]}&doc=${enc[2]}`;
        } else if (plain) {
          u.search = `?tpDoc=${plain[1]}&doc=${plain[2]}`;
        } else {
          const tpDoc = u.searchParams.get("tpDoc");
          const hasDoc = u.searchParams.has("doc") || u.searchParams.has("Doc");
          if (tpDoc && tpDoc.includes("=") && !hasDoc) {
            const [tipo, numero] = tpDoc.split("=");
            u.searchParams.set("tpDoc", tipo);
            u.searchParams.set("doc", numero);
          }
          if (!u.searchParams.get("doc") && trackingNumbers.length > 0) {
            u.searchParams.set("doc", String(trackingNumbers[0]).trim());
            if (!u.searchParams.get("tpDoc")) u.searchParams.set("tpDoc", "4");
          }
        }
      }
      return u.toString();
    } catch {
      if (trackingNumbers.length > 0) {
        const n = String(trackingNumbers[0]).trim();
        return `https://elements.acompanharentrega.com.br/?tpDoc=4&doc=${encodeURIComponent(n)}`;
      }
      return rawUrl;
    }
  }

  // ===== FUNÇÃO DE FETCH DO DATAFRETE (NOVO) =====
  async function buscarStatusDataFrete(numeroNF, serie = '001') {
    // Primeiro, mostra o loading
    const btnRastreio = document.querySelector(".evaluateOrder");
    if (!btnRastreio) return null;

    // Cria ou atualiza o elemento de status com loading
    let statusContainer = document.querySelector(".datafrete-status-container");
    if (!statusContainer) {
      statusContainer = document.createElement("div");
      statusContainer.className = "datafrete-status-container";
      statusContainer.style.cssText = `
        margin-bottom: 15px;
        padding: 12px;
        background: #f0f0f0;
        border-radius: 8px;
        border-left: 4px solid #5223DE;
      `;
      btnRastreio.parentNode.insertBefore(statusContainer, btnRastreio);
    }

    // Mostra loading enquanto busca
    statusContainer.innerHTML = `
      <div style="display: flex; align-items: center; gap: 10px;">
        <div style="width: 18px; height: 18px; border: 2px solid #ccc; border-top: 2px solid #5223DE; border-radius: 50%; animation: spin 1s linear infinite;"></div>
        <span style="color: #666; font-size: 14px;">Buscando status de entrega...</span>
      </div>
      <style>@keyframes spin { to { transform: rotate(360deg); } }</style>
    `;

    try {
      // Chama a API DataFrete via Vercel
      const res = await fetch(`https://datafreteapi.vercel.app/api/datafrete-status?numero=${numeroNF}&serie=${serie}`);
      if (!res.ok) throw new Error(`Resposta do DataFrete não foi OK: ${res.status}`);

      const json = await res.json();

      if (!json.success || !json.ultimo_status) {
        throw new Error(json.message || "Sem ocorrências");
      }

      const ultimoStatus = json.ultimo_status;

      // Define a cor baseada no código da ocorrência
      let statusColor = "#5223DE"; // Roxo padrão
      let statusIcon = "📦";

      if (ultimoStatus.codigo_ocorrencia === 1) {
        statusColor = "#4caf50"; // Verde - Entregue
        statusIcon = "✅";
      } else if (ultimoStatus.codigo_ocorrencia === 105 || ultimoStatus.desc_ocorrencia?.toLowerCase().includes("entrega")) {
        statusColor = "#ff9800"; // Laranja - Saiu para entrega
        statusIcon = "🚚";
      } else if (ultimoStatus.codigo_ocorrencia >= 20 && ultimoStatus.codigo_ocorrencia < 100) {
        statusColor = "#f44336"; // Vermelho - Problema
        statusIcon = "⚠️";
      }

      // Layout Novo: Bloco Status separado do Botão
      statusContainer.style.background = "transparent";
      statusContainer.style.padding = "0";
      statusContainer.style.borderLeft = "none"; // Remove borda do container pai

      const historico = json.historico || [];

      statusContainer.innerHTML = `
        <!-- 1. Bloco de Status (Cinza Claro + Borda Esquerda) -->
        <div style="background: #f9f9f9; padding: 15px; border-radius: 6px 6px 0 0; border-left: 5px solid ${statusColor};">
            <div style="margin-bottom: 6px;">
              <strong style="color: #000; font-size: 14px;">${ultimoStatus.desc_ocorrencia}</strong> <!-- Texto Preto Forte -->
            </div>
            <div style="font-size: 12px; color: #666;">
              ${ultimoStatus.dt_ocorrencia} às ${ultimoStatus.hora_ocorrencia}
            </div>
            ${ultimoStatus.observacao ? `<div style="font-size: 12px; color: #888; margin-top: 4px;">${ultimoStatus.observacao}</div>` : ''}
        </div>

        <!-- 2. Botão Expansível (Cinza um pouco mais escuro, estilo rodapé do card) -->
        <div style="background: #f0f0f0; border-radius: 0 0 6px 6px; border-top: 1px solid #e5e5e5;">
            <button class="btn-toggle-history" style="width: 100%; background: transparent; border: none; color: #333; font-size: 12px; font-weight: 600; padding: 10px; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 6px; transition: background 0.2s;">
                <span>Ver histórico de entrega</span>
                <span style="font-size: 10px;">▼</span>
            </button>
        </div>
            
        <!-- 3. Timeline Oculta (Aparece abaixo de tudo) -->
        <div class="history-list" style="display: none; margin-top: 20px; padding-left: 10px;">
            ${historico.map((h, i) => {
        const isEntrega = h.codigo_ocorrencia === 1 || (h.desc_ocorrencia && h.desc_ocorrencia.toLowerCase().includes("entrega realizada"));

        // Verde Forte (#4caf50) se for entrega confirmada, senão Preto (#333)
        const hColor = isEntrega ? "#4caf50" : "#333333";

        const isLast = i === historico.length - 1;
        const isFirst = i === 0;

        return `
                <div style="position: relative; padding-left: 20px; padding-bottom: ${isLast ? '0' : '20px'}; border-left: 2px solid ${isLast ? 'transparent' : '#e0e0e0'};">
                    <div style="position: absolute; left: -6px; top: 0; width: 10px; height: 10px; border-radius: 50%; background: #fff; border: 2px solid ${hColor};"></div>
                    <!-- Bolinha preenchida -->
                    <div style="position: absolute; left: -4px; top: 2px; width: 6px; height: 6px; border-radius: 50%; background: ${hColor};"></div>
                    
                    <div style="font-size: 13px; font-weight: ${isFirst ? '700' : '500'}; color: #333; line-height: 1.2;">${h.desc_ocorrencia}</div>
                    <div style="font-size: 11px; color: #777; margin-top: 2px;">${h.dt_ocorrencia} às ${h.hora_ocorrencia}</div>
                    ${h.observacao ? `<div style="font-size: 11px; color: #999; margin-top: 2px; font-style: italic;">${h.observacao}</div>` : ''}
                </div>
                `;
      }).join('')}
        </div>
      `;
      // Ajuste visual das bolinhas da timeline: fiz um estilo de "alvo" (circulo com ponto no meio) ou simples?
      // Vou simplificar para o estilo anterior que o user gostou: bolinha e linha.
      // Vou reverter o estilo da bolinha no replacement content para o simples e sólido.

      // Evento de click para expandir/recolher
      const btnToggle = statusContainer.querySelector('.btn-toggle-history');
      const historyDiv = statusContainer.querySelector('.history-list');
      const arrowSpan = btnToggle ? btnToggle.querySelector('span:last-child') : null;

      if (btnToggle && historyDiv) {
        btnToggle.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation(); // Evita cliques indesejados

          const isHidden = historyDiv.style.display === 'none';
          historyDiv.style.display = isHidden ? 'block' : 'none';
          btnToggle.querySelector('span:first-child').innerText = isHidden ? 'Ocultar histórico' : 'Ver histórico de entrega';
          if (arrowSpan) arrowSpan.innerText = isHidden ? '▲' : '▼';
          btnToggle.style.backgroundColor = isHidden ? '#f9f9f9' : 'transparent';
        });
      }

      // Se entregue, atualiza o botão
      if (ultimoStatus.codigo_ocorrencia === 1) {
        btnRastreio.classList.remove("disabledLinkBtn");
        btnRastreio.innerText = "Pedido Entregue";
        btnRastreio.style.backgroundColor = "#4caf50";
      }

      return json;
    } catch (error) {
      console.error("Erro ao buscar status DataFrete:", error);
      // Remove o loading se falhar
      statusContainer.remove();
      return null;
    }
  }


  // ===== FUNÇÃO DE FETCH DA INTELIPOST (MODIFICADA) =====
  async function buscarRastreamentoIntelipost(idPedido) {
    try {
      const res = await fetch(`https://backend-painel-do-cliente.onrender.com/intelipost/${idPedido}`);
      if (!res.ok) throw new Error(`Resposta da Intelipost não foi OK: ${res.status}`);

      const json = await res.json();
      const data = json.content;

      if (json.status !== "OK") {
        throw new Error("Requisição inválida à Intelipost");
      }

      // 1. Atualiza Previsão de Entrega
      const dataISO = data.estimated_delivery_date_iso;
      const dataReal = dataISO ? new Date(dataISO) : null;
      const strongEntrega = document.querySelector("strong.deliveryForecast");
      if (strongEntrega && dataReal) {
        strongEntrega.innerText = dataReal.toLocaleDateString("pt-BR");
      }

      // 2. Traduz o status
      const statusTraduzido = traducaoStatus.deliveryStatus[data.shipment_order_volume_state] || "Aguardando envio";

      // 3. Atualiza o status principal no card "Entrega"
      const strongStatusEntrega = document.querySelector("strong.statusOrder");
      if (strongStatusEntrega) {
        strongStatusEntrega.innerText = statusTraduzido;
      }

      // 4. Atualiza o status em CADA item do pedido
      const allItemStatus = document.querySelectorAll(".order-item-detail__status");
      allItemStatus.forEach(statusEl => {
        statusEl.innerText = statusTraduzido;
      });

      // 5. Atualiza a Barra de Progresso
      const progressoAtual = calcularProgresso(data.shipment_order_volume_state);
      const corBarra = corProgresso(data.shipment_order_volume_state);
      const progressFill = document.querySelector(".progress-fill-compact");
      const progressLabels = document.querySelectorAll(".progress-labels-compact span");

      if (progressFill) {
        progressFill.style.width = `${progressoAtual}%`;
        progressFill.style.background = corBarra;
      }

      if (progressLabels.length > 0) {
        // progressoAtual é 33 (Confirmado), 66 (Em trânsito), ou 100 (Entregue)
        progressLabels.forEach((label, index) => {
          // index 0 = "Confirmado", index 1 = "Em trânsito", index 2 = "Entregue"
          const thresholds = [33, 66, 100]; // Os pontos de ativação

          // Se o progresso atual for MAIOR ou IGUAL ao limite do label, ativa
          if (progressoAtual >= thresholds[index]) {
            label.classList.add("active");
          } else {
            label.classList.remove("active");
          }
        });
      }

      // 6. Lógica do Comprovante (Removida, pois o botão não está no layout)

    } catch (error) {
      console.error("Erro ao buscar rastreamento:", error);
      // Informa o usuário sobre o erro de forma visual
      const strongStatusEntrega = document.querySelector("strong.statusOrder");
      if (strongStatusEntrega) strongStatusEntrega.innerText = "Erro ao carregar";
      const allItemStatus = document.querySelectorAll(".order-item-detail__status");
      allItemStatus.forEach(statusEl => { statusEl.innerText = "Erro ao carregar"; });
    }
  }

  // ===== FUNÇÃO DE FETCH DA NOTA FISCAL (INTACTA) =====
  async function gerarNotaFiscal(idDaNota) {
    try {
      const response = await fetch(`https://backend-painel-do-cliente.onrender.com/nfe/${idDaNota}`);
      if (!response.ok) throw new Error("Erro ao buscar nota fiscal");
      const dadosNota = await response.json();
      return dadosNota;
    } catch (error) {
      console.error("Erro em gerarNotaFiscal:", error);
      const btnNotaFiscal = document.querySelector("#emitirNotaFiscal");
      if (btnNotaFiscal) {
        btnNotaFiscal.classList.add("disabledLinkBtn");
        btnNotaFiscal.innerText = "NF Indisponível";
      }
    }
  }

  // ===== FUNÇÃO "RENDER" (AGORA É "ATTACH") =====
  // Esta função não cria mais HTML, apenas anexa os eventos e dados.
  function attachDynamicData(pedido, numeroPedido, idPedido) {

    // 1. Botões de Review (Lógica mantida, seletores atualizados)
    const items = document.querySelectorAll(".order-item-detail"); // Seletor novo
    items.forEach((item) => {
      const linkProduto = item.querySelector(".order-item-detail__title")?.getAttribute("href"); // Seletor novo
      if (!linkProduto) return;

      const btn = document.createElement("a");
      btn.href = `${linkProduto}#reviews`;
      btn.classList.add("reviewsBtn");
      btn.target = "_blank";
      btn.innerHTML = '<svg fill="#ffffff" width="17" height="17" viewBox="0 0 1920 1920" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff"><path d="M1915.918 737.475c-10.955-33.543-42.014-56.131-77.364-56.131h-612.029l-189.063-582.1v-.112C1026.394 65.588 995.335 43 959.984 43c-35.237 0-66.41 22.588-77.365 56.245L693.443 681.344H81.415c-35.35 0-66.41 22.588-77.365 56.131-10.955 33.544.79 70.137 29.478 91.03l495.247 359.831-189.177 582.212c-10.955 33.657 1.13 70.25 29.817 90.918 14.23 10.278 30.946 15.487 47.66 15.487 16.716 0 33.432-5.21 47.775-15.6l495.134-359.718 495.021 359.718c28.574 20.781 67.087 20.781 95.662.113 28.687-20.668 40.658-57.261 29.703-91.03l-189.176-582.1 495.36-359.83c28.574-20.894 40.433-57.487 29.364-91.03" fill-rule="evenodd"></path></svg> <span class="textReviews">Verificar Avaliações</span>';
      btn.style = "display: inline-flex; align-items: center; justify-content: center; gap: 6px; background-color: #6734ff; color: white; padding: 8px 16px; border-radius: 5px; text-decoration: none; font-weight: 600; font-size: 14px; margin-top: 6px;";
      btn.addEventListener("mouseenter", () => { btn.style.backgroundColor = "#5223de"; });
      btn.addEventListener("mouseleave", () => { btn.style.backgroundColor = "#6734ff"; });

      const infoDiv = item.querySelector(".order-item-detail__info"); // Seletor novo
      if (infoDiv) infoDiv.appendChild(btn);
    });

    // 2. Botão Rastreio (Lógica mantida, seletor atualizado)
    fetch(`https://shopify-tracking.onrender.com/api/shopify-tracking/${numeroPedido}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Erro na API: ${response.status} ${response.statusText}`);
        return response.json();
      })
      .then(async (data) => {
        const trackingNumbers = Array.isArray(data.tracking_numbers) ? data.tracking_numbers : [];
        const trackingUrls = Array.isArray(data.tracking_urls) ? data.tracking_urls : [];
        let trackingUrl = trackingUrls.find(Boolean) || null;
        trackingUrl = normalizeAcompanharUrl(trackingUrl, trackingNumbers);

        const btnAvaliarEl = document.querySelector(".evaluateOrder"); // Seletor novo
        if (!btnAvaliarEl) return;

        if (trackingUrl) {
          btnAvaliarEl.classList.remove("disabledLinkBtn");
          btnAvaliarEl.href = trackingUrl;
          btnAvaliarEl.innerText = "Rastrear Pedido";

          // ===== NOVO: Busca status DataFrete usando o tracking_number (número da NF) =====
          if (trackingNumbers.length > 0) {
            const numeroNF = String(trackingNumbers[0]).trim();
            console.log(`📦 [DataFrete] Buscando status para NF: ${numeroNF}`);
            await buscarStatusDataFrete(numeroNF, '001');
          }
        } else {
          btnAvaliarEl.classList.add("disabledLinkBtn");
          btnAvaliarEl.removeAttribute("href");
          btnAvaliarEl.innerText = "Rastreio indisponível";
        }
      })
      .catch((error) => {
        console.error("❌ Erro na requisição de rastreio:", error);
        const btnAvaliarEl = document.querySelector(".evaluateOrder");
        if (btnAvaliarEl) {
          btnAvaliarEl.classList.add("disabledLinkBtn");
          btnAvaliarEl.removeAttribute("href");
          btnAvaliarEl.innerText = "Rastreio indisponível";
        }
      });

    // 3. Seta o estado inicial da barra de progresso (com dados do 1º fetch)
    const progressoAtual = calcularProgresso(pedido.status_entrega);
    const corBarra = corProgresso(pedido.status_entrega);
    const progressFill = document.querySelector(".progress-fill-compact");
    if (progressFill) {
      progressFill.style.width = `${progressoAtual}%`;
      progressFill.style.background = corBarra;
    }
    // 3.5. Seta o estado inicial dos LABELS
    const progressLabels = document.querySelectorAll(".progress-labels-compact span");
    if (progressLabels.length > 0) {
      progressLabels.forEach((label, index) => {
        const thresholds = [33, 66, 100]; // Pontos de ativação

        // Se o progresso atual for MAIOR ou IGUAL ao limite do label, ativa
        if (progressoAtual >= thresholds[index]) {
          label.classList.add("active");
        } else {
          label.classList.remove("active");
        }
      });
    }

    // 4. Botão Nota Fiscal (Lógica mantida, seletor atualizado)
    const btnNotaFiscalEl = document.querySelector("#emitirNotaFiscal"); // Seletor novo
    if (btnNotaFiscalEl) {
      btnNotaFiscalEl.addEventListener("click", async () => {
        try {
          const res = await fetch(`https://backend-painel-do-cliente.onrender.com/pedidos/vendas/${idPedido}`);
          if (!res.ok) throw new Error("Erro ao buscar pedido");
          const idNota = await res.json();
          const downloadOptions = await gerarNotaFiscal(idNota);
          if (downloadOptions.pdf) window.open(downloadOptions.pdf, "_blank");
          else if (downloadOptions.xml) window.open(downloadOptions.xml, "_blank");
          else if (downloadOptions.danfe) window.open(downloadOptions.danfe, "_blank");
          else alert("Sem opções de download disponíveis");
        } catch (e) {
          console.log("Erro ao procurar Pedido... ", e);
          btnNotaFiscalEl.innerText = "NF Indisponível";
          btnNotaFiscalEl.classList.add("disabledLinkBtn");
        }
      });
    }
  }

  // ===== PONTO DE ENTRADA (MODIFICADO) =====

  // 1. Seletor do número do pedido ATUALIZADO
  const orderNumberElement = document.querySelector(".order-page-header h1");
  let numeroPedido = null;
  let idPedido = null;

  // 2. Spinner (INTACTO)
  const spinner = document.createElement("div");
  spinner.id = "loadingSpinner";
  spinner.innerHTML = `
    <div style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; background: rgba(255,255,255,0.8); display: flex; align-items: center; justify-content: center; z-index: 10000;">
      <div style="width: 48px; height: 48px; border: 5px solid #ccc; border-top: 5px solid #6734ff; border-radius: 50%; animation: spin 1s linear infinite;"></div>
      <style>@keyframes spin {to {transform: rotate(360deg);}}</style>
    </div>
  `;
  document.body.appendChild(spinner);

  // 3. Extrator de número (INTACTO)
  if (orderNumberElement) {
    const pedido = orderNumberElement.innerText || orderNumberElement.textContent;
    numeroPedido = pedido.split(" ")[1].replace("#", "").trim();
  }
  if (!numeroPedido) {
    console.error("Número do pedido não encontrado na página.");
    spinner.remove();
    return;
  }

  const pedidoName = encodeURIComponent(`#${numeroPedido}`);
  fetch(`https://backend-painel-do-cliente.onrender.com/pedidos/${pedidoName}`)
    .then((res) => res.json())
    .then(async (pedido) => {
      if (pedido.erro) {
        console.error(pedido.erro);
        spinner.remove();
        return;
      }
      idPedido = pedido.id;

      attachDynamicData(pedido, numeroPedido, idPedido);

      buscarRastreamentoIntelipost(idPedido).catch(console.error);

      // ===== NOVO: Buscar NF e status DataFrete =====
      try {
        console.log("🔍 [DataFrete] Iniciando busca de NF para pedido:", idPedido);

        // Busca o ID da NF do pedido
        const resVendas = await fetch(`https://backend-painel-do-cliente.onrender.com/pedidos/vendas/${idPedido}`);
        console.log(" [DataFrete] Resposta vendas:", resVendas.status);

        if (resVendas.ok) {
          const idNota = await resVendas.json();
          console.log(" [DataFrete] ID da Nota:", idNota);

          // Busca os dados da NF para extrair o número
          const resNfe = await fetch(`https://backend-painel-do-cliente.onrender.com/nfe/${idNota}`);
          console.log(" [DataFrete] Resposta NFe:", resNfe.status);

          if (resNfe.ok) {
            const dadosNF = await resNfe.json();
            console.log(" [DataFrete] Dados NF:", dadosNF);

            // Extrai número da NF (pode vir de diferentes campos)
            let numeroNF = dadosNF.numero || dadosNF.nf_numero || dadosNF.invoice_number;
            let serieNF = dadosNF.serie || dadosNF.nf_serie || '001';

            // Se tiver a chave, pode extrqueroair do formato SSNNN (série + número)
            if (dadosNF.numero_serie) {
              const match = dadosNF.numero_serie.match(/(\d+)\/(\d+)/);
              if (match) {
                serieNF = match[1];
                numeroNF = match[2];
              }
            }

            console.log("🔍 [DataFrete] Número NF extraído:", numeroNF, "Série:", serieNF);

            if (numeroNF) {
              console.log(` Buscando status DataFrete para NF: ${serieNF}/${numeroNF}`);
              await buscarStatusDataFrete(numeroNF, serieNF);
            } else {
              console.log(" [DataFrete] Número da NF não encontrado nos dados");
            }
          } else {
            console.log(" [DataFrete] NFe não encontrada");
          }
        } else {
          console.log(" [DataFrete] Vendas não encontrada para este pedido");
        }
      } catch (errDataFrete) {
        console.error("❌ Erro ao buscar status DataFrete:", errDataFrete);
        // Silencioso - não afeta funcionalidade principal
      }

      spinner.remove();
    })
    .catch((err) => {
      console.error(err);
      spinner.remove();
    });
});